import { render } from "./Site_query_monitoring.vue?vue&type=template&id=13b9dc48&scoped=true"
import script from "./Site_query_monitoring.js?vue&type=script&lang=js"
export * from "./Site_query_monitoring.js?vue&type=script&lang=js"

import "./Site_query_monitoring.vue?vue&type=style&index=0&id=13b9dc48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b9dc48"]])

export default __exports__